import { useState, useEffect } from 'react'

interface ViewportInfo {
  userAgent: string
  screenWidth: number
  screenHeight: number
  viewportWidth: number
  viewportHeight: number
  devicePixelRatio: number
  isIOS: boolean
  isAndroid: boolean
  currentScale: string
}

const ViewportScaleDebugger: React.FC<{ enabled?: boolean }> = ({ enabled = false }) => {
  const [info, setInfo] = useState<ViewportInfo | null>(null)
  const [showDebug, setShowDebug] = useState(false)

  useEffect(() => {
    if (!enabled) return

    const updateInfo = () => {
      const userAgent = navigator.userAgent || navigator.vendor
      const isIOS = /iPad|iPhone|iPod/.test(userAgent)
      const isAndroid = /Android/.test(userAgent)
      
      const viewportMeta = document.querySelector('meta[name="viewport"]') as HTMLMetaElement
      const currentScale = viewportMeta?.content || 'Não encontrado'

      setInfo({
        userAgent: userAgent.substring(0, 100) + '...',
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight,
        devicePixelRatio: window.devicePixelRatio || 1,
        isIOS,
        isAndroid,
        currentScale
      })
    }

    updateInfo()

    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'V') {
        setShowDebug(!showDebug)
      }
    }

    window.addEventListener('keydown', handleKeyPress)
    window.addEventListener('resize', updateInfo)
    window.addEventListener('orientationchange', () => {
      setTimeout(updateInfo, 200)
    })

    return () => {
      window.removeEventListener('keydown', handleKeyPress)
      window.removeEventListener('resize', updateInfo)
      window.removeEventListener('orientationchange', updateInfo)
    }
  }, [enabled, showDebug])

  if (!enabled || !showDebug || !info) return null

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 bg-black/90 text-green-400 p-3 rounded-lg text-xs font-mono max-h-60 overflow-y-auto">
      <h4 className="font-bold mb-2 text-white">🔍 Viewport Scale Debug</h4>
      
      <div className="grid grid-cols-2 gap-2 text-[10px]">
        <div>Screen: {info.screenWidth}×{info.screenHeight}</div>
        <div>Viewport: {info.viewportWidth}×{info.viewportHeight}</div>
        <div>DPR: {info.devicePixelRatio}</div>
        <div>iOS: {info.isIOS ? '✅' : '❌'}</div>
        <div>Android: {info.isAndroid ? '✅' : '❌'}</div>
        <div>Platform: {info.isIOS ? 'iOS' : info.isAndroid ? 'Android' : 'Outros'}</div>
      </div>
      
      <div className="mt-2">
        <div className="text-yellow-400 font-bold">Viewport Meta:</div>
        <div className="text-[9px] break-all">{info.currentScale}</div>
      </div>
      
      <div className="mt-2 text-[9px] opacity-70 text-gray-400">
        Ctrl+Shift+V para alternar
      </div>
    </div>
  )
}

export default ViewportScaleDebugger 